import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useDebounce } from "use-debounce";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import errorIcon from "@icons/ic-error.svg";
import { TextInputLabel, RequiredFieldDivError } from "./Contact.styled";

const Contact = (props) => {
  const {
    t,
    formData,
    setFormData,
    objectType,
    objectId,
    isEditMode,
    selectedRelatedContact,
    companyId,
    parents,
    setCheckedRoles,
    dependancies,
    countryId,
  } = props;
  const [selectedContact, setSelectedContact] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isCompanySuggestionsLoading, setCompanySuggestionsLoading] =
    useState(false);
  const [query, setQuery] = useState();
  const [debounceQuery] = useDebounce(query, 700);

  useEffect(() => {
    if (isEditMode) {
      setFormData({
        ...formData,
        contact: {
          value: selectedContact,
          error: "",
          required: true,
        },
      });
    }
    if (!isEditMode) {
      let conatctRoles = [];
      if (selectedContact?.roles?.length > 0) {
        selectedContact?.roles.map((data) => {
          conatctRoles.push(parseInt(data.roleId, 10));
        });
      }
      setFormData({
        ...formData,
        contact: {
          value: selectedContact,
          error: "",
          required: true,
        },
        job: {
          value: selectedContact?.job,
          error: "",
          required: true,
        },
        roles: {
          value: conatctRoles,
          error: "",
          required: true,
        },
      });
      setCheckedRoles(conatctRoles);
    }
  }, [selectedContact]);

  useEffect(() => {
    if (isEditMode) {
      let entityGroupList = [];
      if (formData?.contact?.value) {
        entityGroupList.push({
          name:
            selectedRelatedContact?.contact?.id +
            " - " +
            selectedRelatedContact?.contact?.firstName +
            " " +
            selectedRelatedContact?.contact?.firstName +
            "(" +
            selectedRelatedContact?.contact?.company?.name +
            ")",
          id: selectedRelatedContact?.contact?.id,
        });
      }
      setSelectedContact(entityGroupList[0]);
    } else {
      let url = `/contacts?limit=20&countries=[${countryId}]&companyId=${companyId}&parents=${parents}&dependancies=${dependancies}`;
      getEntityData(url, "all");
    }
  }, []);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    searchEntity();
  }, [debounceQuery]);

  const searchEntity = () => {
    const search = query;
    if (search) {
      let url = `/contacts?search=${search}&limit=20&countries=[${countryId}]&companyId=${companyId}&parents=${parents}&dependancies=${dependancies}`;
      getEntityData(url, "all");
    }
  };
  const getEntityData = (url, type) => {
    setCompanySuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        let entityGroupList = [];
        if (response?.data?.contacts) {
          response.data.contacts.map((key) => {
            entityGroupList.push({
              name:
                key.id +
                " - " +
                key.firstName +
                " " +
                key.lastName +
                " (" +
                key?.company?.name +
                ")",
              id: key.id,

              job: key?.job,
              roles: key?.roles,
            });
          });
          if (
            type === "selectedDefault" &&
            response.data.contacts.length === 1
          ) {
            setSelectedContact([entityGroupList[0]]);
          }
        }
        setCompanyList(entityGroupList);
        setCompanySuggestionsLoading(false);
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setCompanyList([]);
        setCompanySuggestionsLoading(false);
      });
  };

  const inputStylesError = {
    border: "solid 1px red",
    borderRadius: "6px",
    background: `url(${errorIcon}) no-repeat right`,
    backgroundSize: "30px 20px",
  };
  const inputStyles = {
    border: "solid 0px #474747",
    borderRadius: "6px",
  };

  return (
    <>
      <TextInputLabel error={formData.contact.error}>
        {" "}
        {t("CONTACT_TO_LINK")}
        {isCompanySuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabel>
      <Autocomplete
        id="tags-outlined"
        options={companyList}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        getOptionLabel={(option) => option.name || ""}
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={
              formData.contact.error !== "" ? inputStylesError : inputStyles
            }
          />
        )}
        value={selectedContact}
        onKeyUp={handleChange}
        onChange={(event, newValue) => {
          setSelectedContact(newValue);
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
      {formData.contact.error !== "" && (
        <RequiredFieldDivError>{formData.contact.error}</RequiredFieldDivError>
      )}
    </>
  );
};

Contact.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  dependancies: PropTypes.string,
  countryId: PropTypes.number,
};

Contact.defaultProps = {
  isEditMode: false,
  dependancies: "",
  countryId: null,
};
export default withTranslation()(Contact);
